import React, { useEffect, useRef } from "react";

import { Box, BoxProps } from "@catchoftheday/cg-components";
import { keyframes, styled } from "@catchoftheday/theme";

const slideLeft = keyframes`
    0% { opacity: 0; transform: translateX(100%); }
    100% { opacity: 1; transform: translateX(0); }
`;
const slideRight = keyframes`
    0% { opacity: 0; transform: translateX(-100%);  }
    100% { opacity: 1; transform: translateX(0); }
`;

type TransitionDivProps = BoxProps & {
  active: boolean;
  direction: "right" | "left";
  transitionDuration?: number;
};

const TransitionDiv = styled(Box)<TransitionDivProps>`
  overflow-y: scroll;
  max-height: 100%;
  animation: ${({ active, direction }) =>
      active && direction === "left"
        ? slideLeft
        : active && direction === "right"
        ? slideRight
        : "none"}
    300ms ease;
`;

type MenuTransitionContainerProps = TransitionDivProps & {
  children: React.ReactNode;
};

export const MenuTransitionContainer = ({
  active,
  direction,
  transitionDuration = 300,
  children,
  ...props
}: MenuTransitionContainerProps) => {
  const contentContainer = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (contentContainer.current !== null && active) {
      contentContainer.current.scrollTop = 0;
    }
  }, [active]);

  return (
    <TransitionDiv
      ref={contentContainer}
      active={active}
      direction={direction}
      transitionDuration={transitionDuration}
      {...props}
    >
      {children}
    </TransitionDiv>
  );
};
